export default {
	id: 11,
	category_id: 1,
	posts_count: 3,
	filtered_posts_count: 3,
	posts: [
		{
			id: 15,
			name: 'Andrew Jones',
			username: 'andrew',
			created_at: '2021-10-17T11:34:18.156Z',
			cooked: "<p>Thanks for posting this, I'm interested to hear what other folks think.</p>",
			post_number: 2,
		},
		{
			id: 16,
			name: 'Beth Smith',
			username: 'beth',
			created_at: '2021-10-17T11:34:53.978Z',
			cooked: "<p>Great post Cathy! I'll let you know how I go.</p>",
			post_number: 3,
		},
		{
			id: 17,
			name: 'Cathy Roberts',
			username: 'cathy',
			created_at: '2021-10-17T11:34:53.978Z',
			cooked: '<p>Thanks guys! Positive feedback is always appreciated.</p>',
			post_number: 4,
		},
	],
	participants: [
		{
			id: 1,
			username: 'andrew',
			name: 'Andrew Jones',
		},
		{
			id: 2,
			username: 'beth',
			name: 'Beth Smith',
		},
		{
			id: 3,
			username: 'cathy',
			name: 'Cathy Roberts',
		},
	],
};
